import * as roles from '@/assets/common/roles';

export default (roleIdOrName, plural = false) => {
    if (!isNaN(roleIdOrName)) {
        roleIdOrName = Object.keys(roles).find(key => roles[key] === roleIdOrName);
    }

    const translations = {
        SYS_ADMIN_ROLE: `Sys-Admin`,
        ADMIN_ROLE: `Admin`,
        AGENT_ROLE: `Agent`,
        GUEST_ROLE: `Guest`
    };

    const roleName = translations[roleIdOrName];

    if (!roleName) {
        return 'Unknown role';
    }

    return `${roleName}${plural ? 's' : ''}`;
};
